// extracted by mini-css-extract-plugin
module.exports = {"profileButton":"profileButton_profileButton__6Ub3j","account":"profileButton_account__2Y0vU"};